/** @jsxRuntime classic */ /** @jsxFrag React.Fragment */ /** @jsx createElement */ import * as React from 'react';
import { createElement } from '@fluentui/react-jsx-runtime';
import { Portal } from '@fluentui/react-portal';
import { getSlotsNext } from '@fluentui/react-utilities';
/**
 * Render the final JSX of DatePicker
 */ export const renderDatePicker_unstable = (state)=>{
    const { slots , slotProps  } = getSlotsNext(state);
    const { inlinePopup  } = state;
    return /*#__PURE__*/ createElement(React.Fragment, null, /*#__PURE__*/ createElement(slots.root, slotProps.root), slots.popupSurface && (inlinePopup ? /*#__PURE__*/ createElement(slots.popupSurface, slotProps.popupSurface, /*#__PURE__*/ createElement(slots.calendar, slotProps.calendar)) : /*#__PURE__*/ createElement(Portal, null, /*#__PURE__*/ createElement(slots.popupSurface, slotProps.popupSurface, /*#__PURE__*/ createElement(slots.calendar, slotProps.calendar)))));
};
